import * as React from "react";
import Dropdown from "react-bootstrap/Dropdown";
export const BaseDropdown = ({
  title,
  options,
  selectedOption,
  setSelectedOption,
}) => {
  const handleSelect = (key, event) => {
    console.log("My options: " + JSON.stringify(options));
    console.log("Selected " + key);
    setSelectedOption(key);
  };
  return (
    <Dropdown onSelect={handleSelect}>
      {options && (
        <div>
          <Dropdown.Toggle variant="success" id="dropdown-basic">
            {selectedOption ? options[selectedOption] : title}
          </Dropdown.Toggle>

          <Dropdown.Menu>
            {Object.entries(options).map(([key, label]) => (
              <Dropdown.Item key={key} eventKey={key}>
                {label}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </div>
      )}
    </Dropdown>
  );
};

export default BaseDropdown;
